<template>
  <div class="article-page-wrap">
    <div class="articleMain">
      <div class="article-title">
        <h3>{{ theArticle.Title }}</h3>
      </div>
      <div class="article-date">
        <span>{{ formateDate }}</span>
      </div>
      <div class="article-content">
        <div class="cv" style="display: none">
          <img v-lazy:mid="theArticle.CoverImage" class="lazy" alt="" />
        </div>
        <div class="txtContent" v-html="theArticle.Content" />
      </div>
    </div>
    <div class="articleMore">
      <ArticleOption
        v-if="nowPageCate"
        :categories="categories"
        :now-cate="nowPageCate"
        all-option-txt="全部文章"
      />
      <h4>看更多文章</h4>
      <ArticleList
        :category-name="All"
        :is-list="false"
        :is-click-more="true"
        :limit="4"
        :has-limit="true"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

import useAxiosAPI from '@global/composable/api/useAxiosAPI';

import ArticleList from '@page/article/components/parts/ArticleList.vue';
import ArticleOption from '@page/article/components/parts/ArticleOption.vue';

const { getArticleCategoryAPI, getArticleListAPI, getArticleContentAPI } = useAxiosAPI();

const popularList = ref([]);
const theArticle = ref({});
const nowPageCate = ref('');
const categories = ref([]);

function dateFormate(dataSrc) {
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  const dateArray = dataSrc.split('/');
  const y = dateArray[0];
  const m = monthNames[dateArray[1] - 1];
  const d = dateArray[2];

  const date = `${m} ${d}, ${y}`;
  return date;
}

const formateDate = computed(() => {
  if (theArticle.value.PostTime) {
    return dateFormate(theArticle.value.PostTime) || '';
  }
  return '';
});

function getCategory() {
  getArticleCategoryAPI()
    .then((res) => {
      if (res.data.Code === 200) {
        categories.value = res.data.Response.Categories;
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

function getPopularList() {
  getArticleListAPI({
    params: { Category: 'ALL' },
  })
    .then((res) => {
      if (res.data.Code === 200) {
        popularList.value = res.data.Response.Data;
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

function getArticle() {
  const articleID = window.location.href?.split('/mag/article/')[1]?.split('?')[0];

  getArticleContentAPI(articleID, {
    params: {
      id: articleID,
    },
  })
    .then((res) => {
      if (res.data.Code === 200) {
        theArticle.value = res.data.Response;
        nowPageCate.value = res.Response.CategoryCode || 'All';
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

getCategory();
getPopularList();
getArticle();
</script>
